import { actionTypes } from "../constants/aiChatConstants";
import { fromJS } from "immutable";
import { api } from "../api";
import { getToken } from "../utils/local-storage.util";

//TODO: replace with actual API endpoint
// const API_ENDPOINT = "http://localhost:3005/api/v1/revit-model-query/";
const API_PATH = "/insight/";

/**
 * Send a message to the AI assistant
 *
 * @param {Object} data - Message data
 * @param {string} data.chatId - Unique identifier for the chat instance
 * @param {string} data.message - The message text to send
 * @param {Function} [data.cb] - Optional callback function
 *
 * @returns {Function} - Redux thunk action
 */
export const sendAiChatMessage = (data) => {
	return async (dispatch) => {
		const { chatId, message, cb = () => {}, urn } = data;

		// Timestamp for the message
		const timestamp = new Date().toISOString();

		// Immediately add user message to the chat
		dispatch({
			type: actionTypes.ADD_AI_CHAT_MESSAGE,
			payload: fromJS({
				chatId,
				id: `user-${timestamp}`,
				sender: "user",
				text: message,
				timestamp,
			}),
		});

		// Set loading state
		dispatch({
			type: actionTypes.SET_AI_CHAT_LOADING,
			payload: true,
		});

		const requestOptions = {
			method: "POST",
			url: API_PATH + urn,
			headers: {
				Authorization: "Bearer " + getToken(),
				"Content-Type": "application/json",
			},
			data: {
				query: `${message}`,
			},
		};

		return api(requestOptions)
			.then((response) => {
				if (response.status === 200) {
					const aiResponse = response.data.result;

					const payload = {
						chatId,
						id: `ai-${timestamp}`,
						sender: "ai",
						text: aiResponse.humanResponse,
						data: aiResponse.data,
						timestamp,
					};

					dispatch({
						type: actionTypes.ADD_AI_CHAT_MESSAGE,
						payload: fromJS(payload),
					});

					dispatch({
						type: actionTypes.SET_AI_CHAT_LOADING,
						payload: false,
					});

					dispatch({
						type: actionTypes.SET_AI_CHAT_ERROR,
						payload: null,
					});

					cb(null, aiResponse);
				} else {
					throw new Error("Failed to get a response from the AI assistant.");
				}
			})
			.catch((error) => {
				console.error("Error sending message to AI:", error);

				dispatch({
					type: actionTypes.SET_AI_CHAT_ERROR,
					payload: "Failed to send message. Please try again.",
				});

				dispatch({
					type: actionTypes.SET_AI_CHAT_LOADING,
					payload: false,
				});

				cb(error);
			});
	};
};

export const getModelData = (urn) => {
	return async (dispatch) => {
		// set loading state
		dispatch({
			type: actionTypes.SET_MODEL_DATA_LOADING,
			payload: true,
		});

		const requestOptions = {
			method: "POST",
			url: "/insight-extract-data-from-urn/" + urn,
			headers: {
				Authorization: "Bearer " + getToken(),
				"Content-Type": "application/json",
			},
		};

		return api(requestOptions).then(
			(response) => {
				dispatch({
					type: actionTypes.GET_MODEL_DATA,
					payload: fromJS(response.data.result),
				});
				dispatch({
					type: actionTypes.SET_MODEL_DATA_LOADING,
					payload: false,
				});
			},
			(err) => {
				console.log(err);
			}
		);
	};
};

/**
 * Clear the chat history for a specific chat instance
 *
 * @param {string} chatId - Unique identifier for the chat instance
 * @returns {Object} - Redux action
 */
export const clearAiChatHistory = (chatId) => ({
	type: actionTypes.CLEAR_AI_CHAT_HISTORY,
	payload: chatId,
});

/**
 * Clear any error message in the AI chat
 *
 * @returns {Object} - Redux action
 */
export const clearAiChatError = () => ({
	type: actionTypes.CLEAR_AI_CHAT_ERROR,
});
